import { SearchOutlined } from '@ant-design/icons';
import { Button, DatePicker } from 'antd';
import * as Components from 'components';
import { contentService } from 'content/service/contentService';
import { Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import { SetURLSearchParams, useParams } from 'react-router-dom';
import { RevenueInterface } from 'src/domain/revenue/revenue-dashboard/types/revenueDashboardType';
interface RevenueProps {
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
}

export const Revenue: React.FC<RevenueProps> = ({ searchParams, setSearchParams }) => {
  const { id } = useParams<{ id: string }>();
  const [selectStartYearMonth, setSelectStartYearMonth] = useState<Moment>();
  const [selectEndYearMonth, setSelectEndYearMonth] = useState<Moment>();
  const [onClickSearch, setOnClickSearch] = useState<boolean>(false);
  const columns = [
    {
      title: 'Year/Month',
      dataIndex: 'yearmon',
      key: 'yearmon',
      width: '8%',
    },
    {
      title: 'Content Provider',
      dataIndex: 'content_provider',
      key: 'content_provider',
      width: '10%',
    },
    {
      title: 'Title',
      dataIndex: 'title_ko',
      key: 'title_ko',
      width: '10%',
    },
    {
      title: 'SVOD Revenue',
      dataIndex: 'svod_revenue',
      key: 'svod_revenue',
      width: '8%',
    },
    {
      title: 'SVOD Net Revenue',
      dataIndex: 'svod_net_revenue',
      key: 'svod_net_revenue',
      width: '8%',
    },
    {
      title: 'SVOD VH',
      dataIndex: 'svod_vh',
      key: 'svod_vh',
      width: '8%',
    },
    {
      title: 'SVOD VP',
      dataIndex: 'svod_vp',
      key: 'svod_vp',
      width: '8%',
    },
    {
      title: 'AVOD Revenue',
      dataIndex: 'avod_revenue',
      key: 'avod_revenue',
      width: '8%',
    },
    {
      title: 'AVOD Net Revenue',
      dataIndex: 'net_avod_revenue',
      key: 'net_avod_revenue',
      width: '8%',
    },
    {
      title: 'AVOD VH',
      dataIndex: 'avod_vh',
      key: 'avod_vh',
      width: '8%',
    },
    {
      title: 'AVOD VP',
      dataIndex: 'avod_vp',
      key: 'avod_vp',
      width: '8%',
    },
    {
      title: 'AVOD RS Rate',
      dataIndex: 'avod_rs_rate',
      key: 'avod_rs_rate',
      width: '8%',
    },
    {
      title: 'AVOD X RS Rate',
      dataIndex: 'avod_x_rs_rate',
      key: 'avod_x_rs_rate',
      width: '8%',
    },
    {
      title: 'Total RS Amount',
      dataIndex: 'total_rs_amount',
      key: 'total_rs_amount',
      width: '8%',
    },
  ];

  const fetchRevenue = async (
    params: URLSearchParams
  ): Promise<{ data: RevenueInterface[]; count: number }> => {
    const queryParams = {
      content_id: id || '',
      page: params.get('page') || '',
      page_size: params.get('page_size') || '',
      start_year_month: selectStartYearMonth ? selectStartYearMonth.format('YYYY-MM') : '',
      end_year_month: selectEndYearMonth ? selectEndYearMonth.format('YYYY-MM') : '',
      group_by: 'content',
    };
    const revenueData = await contentService.fetchRevenueShareData(queryParams);
    return { data: revenueData.results, count: revenueData.count };
  };

  useEffect(() => {
    if (onClickSearch) {
      setOnClickSearch(false);
    }
  }, [onClickSearch]);

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        시작
        <DatePicker.MonthPicker
          style={{ marginLeft: '10px', marginRight: '10px' }}
          placeholder="Start Year/Month"
          value={selectStartYearMonth}
          onChange={date => setSelectStartYearMonth(date)}
        />
        종료
        <DatePicker.MonthPicker
          placeholder="End Year/Month"
          value={selectEndYearMonth}
          style={{ marginLeft: '10px', marginRight: '10px' }}
          onChange={date => setSelectEndYearMonth(date)}
        />
        <Button
          type="primary"
          icon={<SearchOutlined />}
          style={{
            marginLeft: '10px',
            backgroundColor: 'white',
            color: 'black',
            border: '1px solid #d9d9d9',
          }}
          onClick={() => {
            setOnClickSearch(true);
          }}
        >
          search
        </Button>
      </div>
      <Components.TableComponent
        name="Revenue"
        dataFetch={fetchRevenue}
        columns={columns}
        options={{
          isDisableIdColumn: true,
        }}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    </>
  );
};

export default Revenue;
